// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nz22","footer":"styles_footer__1G85l","passCodeTooltip":"styles_passCodeTooltip__3RIQC"};